import createPointerReduxUtil from 'modules/redux/utils/create-pointer'
import isInstanceReduxUtil from 'modules/redux/utils/is-instance'
import isPointerReduxUtil from 'modules/redux/utils/is-pointer'
import addReferenceCreateReduxUtil from 'modules/redux/actions/create/add-reference'
import createInstanceCreateUtil from 'modules/redux/actions/create/create-instance'

export default function createPointerCreateReduxUtil (stateWrapper, payload) {
  const {
    existingInstance,
    referencePath,
    association,
    properties,
    isLocal
  } = payload
  if (isPointerReduxUtil(association)) {
    return association
  }
  // Create the pointer
  let instance
  if (isInstanceReduxUtil(association)) {
    instance = association
  } else {
    instance = createInstanceCreateUtil(stateWrapper, {
      data: {
        [isLocal ? 'changed' : 'data']: association,
        className: association.className,
        ...properties
      },
      isLocal,
      existingInstance
    })
  }
  const pointer = createPointerReduxUtil(instance)
  // Add the referencePath to the list of paths referencing the pointer
  stateWrapper.state = addReferenceCreateReduxUtil({
    instance,
    referencePath,
    stateWrapper
  })
  return pointer
}
